import {
  PerspectiveGroupingRule,
  PerspectivesGroupsOptions,
} from '@ardoq/perspectives';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  createGroupingRule,
  reorderGroupingRules,
  updateGroupingRule,
  deleteGroupingRule,
} from 'perspective/perspectiveEditor/perspectivesEditor$/actions';
import * as actions from './viewpointGroupingRulesActions';
import type { GetGroupingOptionsPayload } from './viewpointGroupingRulesActions';

export const getViewpointGroupingRulesCommands = (namespace: string) => ({
  onGroupingRuleReordered: (
    reorderedGroupingRules: PerspectiveGroupingRule[]
  ) => dispatchAction(reorderGroupingRules(reorderedGroupingRules), namespace),

  onGroupingRuleDeleted: (deletedGroupingRuleId: string) =>
    dispatchAction(deleteGroupingRule(deletedGroupingRuleId), namespace),

  onGroupingRuleUpdated: (
    updatedGroupingRuleId: string,
    updatedGroupingRule: Partial<PerspectiveGroupingRule>
  ) =>
    dispatchAction(
      updateGroupingRule({ updatedGroupingRuleId, updatedGroupingRule }),
      namespace
    ),

  onGroupingRuleAdded: (newGroupingRule: PerspectiveGroupingRule) =>
    dispatchAction(createGroupingRule(newGroupingRule), namespace),

  getGroupingOptions: (getGroupingOptionsPayload: GetGroupingOptionsPayload) =>
    dispatchAction(
      actions.getGroupingOptions(getGroupingOptionsPayload),
      namespace
    ),

  setGroupingOptions: (setGroupingOptionsPayload: PerspectivesGroupsOptions) =>
    dispatchAction(
      actions.setGroupingOptions(setGroupingOptionsPayload),
      namespace
    ),

  setGroupingRules: (groupingRules: PerspectiveGroupingRule[]) =>
    dispatchAction(actions.setGroupingRules({ groupingRules }), namespace),
});

export type ViewpointGroupingRulesCommands = ReturnType<
  typeof getViewpointGroupingRulesCommands
>;
